import { apiService } from '../../api/apiService';

export const getLicenseInfo =
  () =>
    async (
    ) => {
      const response = await apiService.licenseV10CurrentList();
      return response;
    };